import { AcLockObject } from '@utils/ac-lock-object';

const API = '/api';
const FAQS = '/faqs';
const PUBLIC = '/public';
const PAGES = '/pages';
const PUBLICATIONS = '/publications';
const SEARCH = '/search';
const ATTACHMENTS = '/attachments';
const THEMES = '/themes';
const CATEGORIES = '/categories';
const TERMS = '/terms';

// OpenCatalogi publications API: base-URL (API_URL_COMMONGROUND) bevat al
// {host}/apps/opencatalogi/api; paden zijn relatief aan de catalogus.
const API_CONDUCTION = '';

export const ENDPOINTS = AcLockObject({
  PUBLICATIONS: {
    SEARCH: `${API_CONDUCTION}${PUBLICATIONS}`, // GET
    SINGLE: (_id) => `${API_CONDUCTION}${PUBLICATIONS}/${_id}`, // GET
    ATTACHMENTS: (_id) => `${API_CONDUCTION}${PUBLICATIONS}/${_id}${ATTACHMENTS}`, // GET
  },
  THEMES: {
    INDEX: `${API_CONDUCTION}${THEMES}`,
  },
  FAQS: {
    INDEX: `${API}${PUBLIC}${FAQS}`, // GET
    SHOW: (_id) => `${API}${PUBLIC}${FAQS}${_id}`, // GET
  },
  PAGES: {
    INDEX: `${API}${PUBLIC}${PAGES}`, // GET
    SHOW: (_slug) => `${API}${PUBLIC}${PAGES}${_slug}`, // GET
  },
  CATEGORIES: {
    INDEX: `${API}${PUBLIC}${CATEGORIES}`, // GET
    SHOW: (_id) => `${API}${PUBLIC}${CATEGORIES}/${_id}`, // GET
  },
  TERMS: {
    INDEX: `${API}${PUBLIC}${TERMS}`, // GET
    SHOW: (_id) => `${API}${PUBLIC}${TERMS}/${_id}`, // GET
  },
});

export default ENDPOINTS;
